"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeparateModalFooter = exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PopupDialog = _interopRequireDefault(require("./PopupDialog"));

var _LoaderComponent = _interopRequireDefault(require("./LoaderComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('../../../sass/components/shared/elements/UniversalDashModal.css');

var classNames = require('classnames');

var bool = _propTypes.default.bool,
    func = _propTypes.default.func,
    shape = _propTypes.default.shape,
    string = _propTypes.default.string,
    object = _propTypes.default.object;

var UniversalDashModal = /*#__PURE__*/function (_React$Component) {
  _inherits(UniversalDashModal, _React$Component);

  var _super = _createSuper(UniversalDashModal);

  function UniversalDashModal(props) {
    var _this;

    _classCallCheck(this, UniversalDashModal);

    _this = _super.call(this, props);
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.handleOverlayClick = _this.handleOverlayClick.bind(_assertThisInitialized(_this));
    _this.closePhotoUpload = _this.closePhotoUpload.bind(_assertThisInitialized(_this));
    _this.handleMainButtonClick = _this.handleMainButtonClick.bind(_assertThisInitialized(_this));
    _this.resetError = _this.resetError.bind(_assertThisInitialized(_this));
    _this.successDialog = _this.successDialog.bind(_assertThisInitialized(_this));
    _this.errorDialog = _this.errorDialog.bind(_assertThisInitialized(_this));
    _this.handleSuccess = _this.handleSuccess.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UniversalDashModal, [{
    key: "closeModal",
    value: function closeModal() {
      this.props.closeModal();
    }
  }, {
    key: "handleOverlayClick",
    value: function handleOverlayClick() {
      if (this.props.closeableWithOverlay) {
        this.closeModal();
      }
    }
  }, {
    key: "closePhotoUpload",
    value: function closePhotoUpload() {
      this.props.handlePhotoUploadClose();
    }
  }, {
    key: "handleMainButtonClick",
    value: function handleMainButtonClick() {
      this.props.mainButtonFn();
    }
  }, {
    key: "resetError",
    value: function resetError() {
      this.props.editCompanyReset();
      this.closeModal();
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess() {
      if (!this.props.showSuccess) {
        this.resetError();
      } else {
        this.successDialog();
      }
    }
  }, {
    key: "successDialog",
    value: function successDialog() {
      var title = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "tumb-emoji"
      }), this.props.submittedTitle ? this.props.submittedTitle : 'Account Updated');

      return /*#__PURE__*/_react.default.createElement(_PopupDialog.default, {
        title: title,
        actions: [{
          label: 'Done',
          primary: true,
          onClick: this.resetError
        }]
      }, "Your ", this.props.submittedText ? this.props.submittedText : 'account', " information has been successfully updated.");
    }
  }, {
    key: "errorDialog",
    value: function errorDialog(_ref) {
      var http_code = _ref.http_code,
          code = _ref.code,
          message = _ref.message,
          original = _ref.original;
      var body;

      if (original && original.length && http_code === 400 && (code === 108 || code === 109)) {
        body = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, message), /*#__PURE__*/_react.default.createElement("ul", {
          className: "error-list"
        }, original.map(function (reason, idx) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: idx
          }, /*#__PURE__*/_react.default.createElement("span", null, reason));
        })));
      } else {
        body = message;
      }

      return /*#__PURE__*/_react.default.createElement(_PopupDialog.default, {
        title: "Cannot make update",
        actions: [{
          label: 'Try Again',
          onClick: this.resetError,
          primary: true
        }],
        actAsExpander: !!original,
        showExpandableButton: !!original,
        stackTrace: original && original.stack
      }, body);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          customClass = _this$props.customClass,
          headerTitle = _this$props.headerTitle,
          hideCloseButton = _this$props.hideCloseButton,
          photoUploadOpen = _this$props.photoUploadOpen,
          photoHeaderTitle = _this$props.photoHeaderTitle,
          isFetching = _this$props.isFetching,
          isPhotoUploading = _this$props.isPhotoUploading,
          submitted = _this$props.submitted,
          error = _this$props.error,
          disabled = _this$props.disabled,
          prevModal = _this$props.prevModal,
          returnPrevModal = _this$props.returnPrevModal,
          noFooter = _this$props.noFooter,
          mainButtonText = _this$props.mainButtonText,
          secondaryButtonText = _this$props.secondaryButtonText,
          secondaryButtonHide = _this$props.secondaryButtonHide,
          secondaryButtonFn = _this$props.secondaryButtonFn,
          tertiaryButtonText = _this$props.tertiaryButtonText,
          tertiaryButtonHide = _this$props.tertiaryButtonHide,
          tertiaryButtonFn = _this$props.tertiaryButtonFn,
          v3Styling = _this$props.v3Styling;
      var modalClasses = classNames(_defineProperty({
        'universal-dash-modal': true,
        'v3-styling': v3Styling
      }, customClass, customClass));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: modalClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "universal-dash-modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "universal-dash-modal-header"
      }, photoUploadOpen ? photoHeaderTitle : headerTitle, !hideCloseButton && /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-close-button",
        onClick: prevModal && returnPrevModal ? returnPrevModal : this.closeModal
      })), children, !noFooter && /*#__PURE__*/_react.default.createElement("div", {
        className: "universal-dash-modal-footer"
      }, (photoUploadOpen || prevModal && returnPrevModal) && /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-back-button",
        onClick: photoUploadOpen && this.closePhotoUpload ? this.closePhotoUpload : returnPrevModal
      }, "Back"), tertiaryButtonText && !tertiaryButtonHide && /*#__PURE__*/_react.default.createElement("button", {
        className: "modal-tertiary-button",
        onClick: tertiaryButtonFn
      }, tertiaryButtonText), secondaryButtonText && !secondaryButtonHide && /*#__PURE__*/_react.default.createElement("button", {
        className: "modal-secondary-button",
        onClick: secondaryButtonFn
      }, secondaryButtonText), /*#__PURE__*/_react.default.createElement("button", {
        className: "modal-primary-button",
        onClick: this.handleMainButtonClick,
        disabled: disabled
      }, photoUploadOpen ? 'Crop' : mainButtonText))), /*#__PURE__*/_react.default.createElement("div", {
        className: "universal-dash-modal-overlay",
        onClick: this.handleOverlayClick
      }), (isFetching || isPhotoUploading) && /*#__PURE__*/_react.default.createElement(_LoaderComponent.default, null), submitted ? this.handleSuccess() : '', error && error.message && this.errorDialog(error));
    }
  }]);

  return UniversalDashModal;
}(_react.default.Component);

exports.default = UniversalDashModal;
UniversalDashModal.propTypes = {
  closeableWithOverlay: bool,
  closeModal: func.isRequired,
  editCompanyReset: func,
  error: shape({}),
  handlePhotoUploadClose: func,
  hideCloseButton: bool,
  isFetching: bool,
  isPhotoUploading: bool,
  mainButtonFn: func,
  mainButtonText: string,
  secondaryButtonFn: func,
  secondaryButtonHide: bool,
  secondaryButtonText: string,
  tertiaryButtonFn: func,
  tertiaryButtonHide: bool,
  tertiaryButtonText: string,
  noFooter: bool,
  photoHeaderTitle: string,
  photoUploadOpen: bool,
  submitted: bool,
  showSuccess: bool,
  v3Styling: bool
};
UniversalDashModal.defaultProps = {
  closeableWithOverlay: true,
  closeModal: function closeModal() {},
  editCompanyReset: function editCompanyReset() {},
  error: {},
  handlePhotoUploadClose: function handlePhotoUploadClose() {},
  headerTitle: '',
  hideCloseButton: false,
  isFetching: false,
  isPhotoUploading: false,
  mainButtonFn: function mainButtonFn() {},
  secondaryButtonFn: function secondaryButtonFn() {},
  secondaryButtonHide: false,
  tertiaryButtonFn: function tertiaryButtonFn() {},
  tertiaryButtonHide: false,
  tertiaryButtonText: '',
  mainButtonText: '',
  noFooter: false,
  photoHeaderTitle: '',
  photoUploadOpen: false,
  submitted: false,
  showSuccess: false,
  v3Styling: false
};

var SeparateModalFooter = function SeparateModalFooter(_ref2) {
  var _ref2$tertiaryButtonF = _ref2.tertiaryButtonFn,
      tertiaryButtonFn = _ref2$tertiaryButtonF === void 0 ? function () {} : _ref2$tertiaryButtonF,
      tertiaryButtonHide = _ref2.tertiaryButtonHide,
      _ref2$tertiaryButtonT = _ref2.tertiaryButtonText,
      tertiaryButtonText = _ref2$tertiaryButtonT === void 0 ? '' : _ref2$tertiaryButtonT,
      _ref2$secondaryButton = _ref2.secondaryButtonFn,
      secondaryButtonFn = _ref2$secondaryButton === void 0 ? function () {} : _ref2$secondaryButton,
      secondaryButtonHide = _ref2.secondaryButtonHide,
      _ref2$secondaryButton2 = _ref2.secondaryButtonText,
      secondaryButtonText = _ref2$secondaryButton2 === void 0 ? '' : _ref2$secondaryButton2,
      _ref2$mainButtonText = _ref2.mainButtonText,
      mainButtonText = _ref2$mainButtonText === void 0 ? '' : _ref2$mainButtonText,
      _ref2$mainButtonFn = _ref2.mainButtonFn,
      mainButtonFn = _ref2$mainButtonFn === void 0 ? function () {} : _ref2$mainButtonFn,
      disabled = _ref2.disabled;
  var footerClasses = classNames('universal-dash-modal-footer', 'separate-footer');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: footerClasses
  }, tertiaryButtonText && !tertiaryButtonHide && /*#__PURE__*/_react.default.createElement("button", {
    className: "modal-tertiary-button",
    onClick: tertiaryButtonFn
  }, tertiaryButtonText), secondaryButtonText && !secondaryButtonHide && /*#__PURE__*/_react.default.createElement("button", {
    className: "modal-secondary-button",
    onClick: secondaryButtonFn
  }, secondaryButtonText), /*#__PURE__*/_react.default.createElement("button", {
    className: "modal-primary-button",
    onClick: mainButtonFn,
    disabled: disabled
  }, mainButtonText));
};

exports.SeparateModalFooter = SeparateModalFooter;